{
  "_meta": {
    "_comment": "Admin vendors namespace. Phase 18 Task 34 added detail.tabs.integration. vg-binding: P18.D-21 | vg-binding: PLAN:task-34",
    "locale": "vi"
  },
  "list": {
    "page": {
      "heading": "Nhà cung cấp",
      "subtitle": "Quản lý hồ sơ, KYC, kích hoạt, công suất và rủi ro của nhà cung cấp. Nhấp vào một hàng để xem trang chi tiết."
    },
    "filter": {
      "showClosed": "Hiện nhà cung cấp đã đóng"
    },
    "empty": {
      "message": "Không có nhà cung cấp nào phù hợp với bộ lọc của bạn."
    },
    "legend": {
      "label": "Chú thích hàng:",
      "suspended": "Đã tạm dừng",
      "atRisk": "Có rủi ro",
      "lowRating": "Đánh giá thấp (< 0.5)",
      "pendingActivation": "Chờ kích hoạt",
      "ariaLabel": "Chú thích màu hàng"
    },
    "wallet": {
      "onHold": "Đang giữ",
      "open": "Mở",
      "onHoldTitle": "Ví đang bị giữ — thanh toán bị chặn bởi quản trị viên"
    },
    "kyc": {
      "pendingTitle": "Thanh toán bị chặn. Đơn hàng được phép."
    },
    "capabilities": {
      "pendingTitle": "Đề xuất năng lực đang chờ duyệt"
    },
    "toast": {
      "actionRequiresDetailTitle": "Hành động cần trang chi tiết",
      "actionRequiresDetailDesc": "Mở trang chi tiết nhà cung cấp để hoàn thành hành động này. Hộp thoại hàng loạt sẽ có trong Wave 5.",
      "activationQueueTitle": "Duyệt trong hàng chờ kích hoạt",
      "activationQueueDesc": "Đã mở hàng chờ nhà cung cấp — bấm vào dòng nhà cung cấp để xem xét và duyệt kích hoạt.",
      "suspendedTitle": "Đã tạm dừng nhà cung cấp",
      "reactivatedTitle": "Đã kích hoạt lại nhà cung cấp",
      "networkError": "Lỗi mạng — kiểm tra kết nối",
      "noVendorsTitle": "Chưa chọn nhà cung cấp",
      "noVendorsDesc": "Chọn ít nhất một nhà cung cấp để thực hiện hành động hàng loạt.",
      "reasonRequiredTitle": "Cần lý do",
      "reasonRequiredDesc": "Vui lòng nhập lý do từ 10–500 ký tự để tiếp tục.",
      "dualApprovalTitle": "Yêu cầu phê duyệt kép",
      "dualApprovalDesc": "Yêu cầu {{approvalId}} đã xếp hàng (SLA {{slaMinutes}} phút, {{vendorCount}} nhà cung cấp).",
      "jobQueuedTitle": "Công việc đã xếp hàng",
      "jobQueuedDesc": "Công việc nền {{jobId}}. Theo dõi qua {{pollUrl}}.",
      "bulkCompleteTitle": "Hành động hàng loạt hoàn tất",
      "bulkCompleteDesc": "{{count}} nhà cung cấp đã được cập nhật.",
      "partialSuccessTitle": "Thành công một phần",
      "partialSuccessDesc": "{{succeeded}} thành công, {{failed}} thất bại.",
      "bulkFailedTitle": "Hành động hàng loạt thất bại"
    },
    "bulkActions": {
      "suspend": "Tạm dừng",
      "suspendLabel": "Tạm dừng nhà cung cấp",
      "activate": "Kích hoạt",
      "activateLabel": "Kích hoạt nhà cung cấp",
      "holdWallet": "Giữ ví",
      "holdWalletLabel": "Giữ ví nhà cung cấp",
      "releaseWallet": "Mở khóa ví",
      "releaseWalletLabel": "Mở khóa ví nhà cung cấp",
      "exportCsv": "Xuất CSV",
      "exportLabel": "Xuất danh sách nhà cung cấp",
      "perVendorSuspendLabel": "Tạm dừng nhà cung cấp",
      "perVendorReactivateLabel": "Kích hoạt lại nhà cung cấp"
    },
    "actions": {
      "confirm": "Xác nhận",
      "vendorSettings": "Cài đặt Vendor",
      "createVendor": "Tạo nhà cung cấp",
      "importVendors": "Nhập hàng loạt"
    }
  },
  "listColumns": {
    "headers": {
      "name": "Nhà cung cấp",
      "status": "Trạng thái",
      "wallet": "Ví",
      "kyc": "KYC",
      "rating": "Đánh giá",
      "utilization": "Mức sử dụng",
      "pendingOrders": "Chờ xử lý",
      "sla": "SLA",
      "backOrder": "Đơn tồn",
      "totalEarned": "Tổng thu nhập",
      "pendingPayout": "Chờ chi trả",
      "atRisk": "Rủi ro",
      "capPending": "Năng lực chờ",
      "region": "Khu vực",
      "created": "Ngày tạo"
    },
    "filters": {
      "search": {
        "label": "Tìm kiếm",
        "placeholder": "Tên, email, điện thoại, ID…"
      },
      "status": {
        "label": "Trạng thái",
        "options": {
          "pending_activation": "Chờ kích hoạt",
          "active": "Đang hoạt động",
          "inactive": "Ngừng hoạt động",
          "suspended": "Đã đình chỉ",
          "closed": "Đã đóng"
        }
      },
      "wallet": {
        "label": "Ví",
        "options": {
          "hold": "Đang giữ",
          "open": "Mở"
        }
      },
      "kyc": {
        "label": "KYC",
        "options": {
          "approved": "Đã duyệt",
          "pending": "Chờ duyệt",
          "rejected": "Đã từ chối"
        }
      },
      "atRisk": {
        "label": "Mức độ rủi ro",
        "options": {
          "low": "Thấp",
          "medium": "Trung bình",
          "high": "Cao"
        }
      },
      "region": {
        "label": "Khu vực",
        "placeholder": "Mã quốc gia / khu vực"
      }
    }
  },
  "rowMenu": {
    "menuAria": "Hành động cho nhà cung cấp {{id}}",
    "triggerAria": "Mở hành động cho nhà cung cấp {{id}}",
    "items": {
      "view": "Xem chi tiết",
      "approve_kyc": "Duyệt KYC",
      "approve_activation": "Duyệt kích hoạt",
      "capability_review": "Xem xét năng lực",
      "acknowledge_at_risk": "Xác nhận rủi ro",
      "reactivate": "Kích hoạt lại",
      "suspend": "Tạm dừng"
    }
  },
  "tabs": {
    "listAria": "Tab danh sách nhà cung cấp",
    "countAria": "{{count}} nhà cung cấp",
    "labels": {
      "all": "Tất cả",
      "pending_activation": "Chờ kích hoạt",
      "active": "Đang hoạt động",
      "inactive": "Không hoạt động",
      "suspended": "Đã tạm dừng",
      "pending_cost_approvals": "Chờ duyệt chi phí",
      "pending_capabilities": "Chờ duyệt năng lực",
      "at_risk": "Có rủi ro"
    },
    "descriptions": {
      "all": "Tất cả nhà cung cấp bất kể trạng thái.",
      "pending_activation": "Nhà cung cấp chờ quản trị viên phê duyệt. Nhà cung cấp mới sẽ xuất hiện ở đây cho đến khi được kích hoạt.",
      "pending_cost_approvals": "Nhà cung cấp có yêu cầu phê duyệt chi phí đang mở. Từ backend Phase 7.",
      "pending_capabilities": "Nhà cung cấp có đề xuất năng lực đang chờ. Mỗi đề xuất cần quản trị viên xem xét.",
      "at_risk": "Nhà cung cấp bị gắn cờ rủi ro. Bao gồm: đánh giá thấp, tỷ lệ từ chối cao, khiếu nại tăng đột biến."
    }
  },
  "pinnedOverview": {
    "cards": {
      "profile": "Hồ sơ",
      "performance": "Hiệu suất",
      "capacity": "Công suất",
      "financial": "Tài chính"
    },
    "profile": {
      "email": "Email",
      "phone": "Điện thoại",
      "country": "Quốc gia",
      "primaryContact": "Người liên hệ chính",
      "tier": "Hạng",
      "yearsActive": "Số năm hoạt động"
    },
    "performance": {
      "rating": "Đánh giá",
      "delta30d": "Δ 30 ngày",
      "orders30d": "Đơn hàng 30 ngày",
      "rejectionRate": "Tỷ lệ từ chối",
      "slaCompliance": "Tuân thủ SLA",
      "manualAdjust": "Điều chỉnh đánh giá thủ công"
    },
    "capacity": {
      "costGatedMsg": "Bị giới hạn — yêu cầu quyền VIEW_FINANCIAL_COST để xem mức sử dụng công suất.",
      "slots": "vị trí",
      "frozen": "đã đóng băng"
    },
    "financial": {
      "wallet": "Ví",
      "pendingPayout": "Thanh toán chờ xử lý",
      "earnings30d": "Thu nhập 30 ngày",
      "outstandingInvoice": "Hóa đơn chưa thanh toán"
    }
  },
  "detail": {
    "tabs": {
      "ariaLabel": "Các mục chi tiết nhà cung cấp",
      "locations": "Địa điểm",
      "capabilities": "Năng lực",
      "products": "Sản phẩm",
      "pending-cost-approvals": "Duyệt giá",
      "recent-orders": "Đơn gần đây",
      "financial": "Tài chính",
      "activity-log": "Hoạt động",
      "notes": "Ghi chú",
      "kyc": "KYC",
      "staff-accounts": "Nhân viên",
      "sla-chart": "SLA",
      "integration": "Tích hợp",
      "badgeNew": "MỚI"
    },
    "backLink": "Quay lại Vendors",
    "loading": "Đang tải nhà cung cấp…",
    "error": {
      "missingId": "Thiếu ID nhà cung cấp trong route — không thể hiển thị chi tiết.",
      "loadFail": "Không thể tải nhà cung cấp: {{message}}",
      "noData": "Không có dữ liệu nhà cung cấp.",
      "impersonateNoUrl": "Cookie giả mạo đã được đặt nhưng không có URL chuyển hướng — hãy mở cổng nhà cung cấp thủ công.",
      "cannotImpersonate": "Vai trò của bạn không thể giả mạo nhà cung cấp."
    },
    "ratingModal": {
      "title": "Điều chỉnh đánh giá thủ công",
      "description": "Hành động này được ghi lại trong nhật ký kiểm toán nhà cung cấp với giá trị trước / sau và lý do của bạn. Ghi đè có hiệu lực cho đến khi quản trị viên khác xóa bỏ.",
      "newRatingLabel": "Đánh giá mới: {{value}} / 5",
      "reasonLabel": "Lý do (tối thiểu 10 ký tự)",
      "reasonTooShort": "Lý do phải có ít nhất 10 ký tự (yêu cầu kiểm toán).",
      "unknownError": "Lỗi không xác định",
      "cancel": "Hủy",
      "saving": "Đang lưu…",
      "save": "Lưu điều chỉnh"
    },
    "confirmDialog": {
      "reasonLabel": "Lý do (không bắt buộc)",
      "unknownError": "Lỗi không xác định",
      "cancel": "Hủy",
      "working": "Đang xử lý…"
    },
    "walletAdjustPlaceholder": {
      "title": "Điều chỉnh ví",
      "description": "Modal điều chỉnh ví đầy đủ sẽ có trong task-26 (§7.1). Tạm thời placeholder này báo hiệu hành động — luồng mutation thực sẽ có ở Wave 7.",
      "close": "Đóng"
    },
    "confirm": {
      "suspend": {
        "title": "Tạm dừng nhà cung cấp",
        "body": "Tạm dừng nhà cung cấp sẽ ngăn định tuyến đơn hàng mới. Các đơn đang xử lý không bị hủy — chúng tiếp tục được thực hiện.",
        "cta": "Xác nhận tạm dừng"
      },
      "reactivate": {
        "title": "Kích hoạt lại nhà cung cấp",
        "body": "Kích hoạt lại nhà cung cấp này để các đơn hàng mới có thể được định tuyến đến họ.",
        "cta": "Xác nhận kích hoạt lại"
      },
      "walletHoldOn": {
        "title": "Giữ ví nhà cung cấp",
        "body": "Giữ ví — thanh toán và rút tiền bị chặn cho đến khi được giải phóng.",
        "cta": "Giữ ví"
      },
      "walletHoldOff": {
        "title": "Giải phóng ví nhà cung cấp",
        "body": "Giải phóng lệnh giữ ví để thanh toán và rút tiền tiếp tục.",
        "cta": "Giải phóng ví"
      }
    }
  },
  "stickyHeader": {
    "statusLabels": {
      "Active": "Hoạt động",
      "Pending": "Chờ kích hoạt",
      "PendingActivation": "Chờ kích hoạt",
      "Suspended": "Tạm dừng",
      "Inactive": "Không hoạt động",
      "AtRisk": "Có rủi ro"
    },
    "rating": {
      "manualTitle": "Ghi đè đánh giá thủ công — hiện tại {{value}} / 5",
      "currentTitle": "Đánh giá hiện tại {{value}} / 5",
      "manual": "Thủ công",
      "manualAdjust": "Điều chỉnh thủ công"
    },
    "online": {
      "online": "Đang trực tuyến",
      "lastSeen": "Lần cuối thấy lúc {{date}}",
      "offline": "Ngoại tuyến"
    },
    "actions": {
      "edit": "Chỉnh sửa",
      "reactivate": "Kích hoạt lại",
      "suspend": "Tạm dừng",
      "releaseWallet": "Giải phóng ví",
      "holdWallet": "Giữ ví",
      "loginAsVendor": "Đăng nhập với tư cách nhà cung cấp"
    },
    "walletHoldBadge": "Ví đang bị giữ"
  },
  "reviewDrawer": {
    "title": "Xét duyệt nhà cung cấp",
    "close": "Đóng",
    "ariaLabel": "Khung xét duyệt nhà cung cấp",
    "closeAriaLabel": "Đóng khung nhà cung cấp",
    "notFound": "Không tìm thấy nhà cung cấp.",
    "toast": {
      "loadFail": "Không thể tải nhà cung cấp",
      "networkError": "Lỗi mạng",
      "unknown": "Không xác định",
      "approveFail": "Phê duyệt thất bại",
      "approveSuccess": "Nhà cung cấp đã được phê duyệt",
      "approveSuccessDesc": "{{displayName}} hiện đang hoạt động.",
      "rejectReasonShort": "Lý do từ chối quá ngắn",
      "rejectReasonShortDesc": "Cần tối thiểu 10 ký tự.",
      "rejectFail": "Từ chối thất bại",
      "rejectSuccess": "Nhà cung cấp đã bị từ chối",
      "rejectSuccessDesc": "Email thông báo đã được gửi vào hàng đợi; thời gian chờ đã được áp dụng."
    },
    "profile": {
      "heading": "Hồ sơ",
      "displayName": "Tên hiển thị",
      "phone": "Điện thoại",
      "country": "Quốc gia",
      "status": "Trạng thái",
      "applied": "Ngày đăng ký",
      "lastReject": "Lần từ chối cuối"
    },
    "survey": {
      "heading": "Câu trả lời khảo sát",
      "empty": "Nhà cung cấp chưa hoàn thành khảo sát đăng ký."
    },
    "actions": {
      "reject": "Từ chối",
      "approve": "Phê duyệt",
      "rejectReasonLabel": "Lý do từ chối (10-2000 ký tự)",
      "rejectReasonPlaceholder": "Giải thích lý do từ chối đơn đăng ký nhà cung cấp này. Sẽ được gửi qua email.",
      "cancel": "Hủy",
      "confirmReject": "Xác nhận từ chối"
    },
    "registration": {
      "heading": "Thông tin đăng ký",
      "businessName": "Tên doanh nghiệp",
      "legalName": "Tên pháp lý",
      "timezone": "Múi giờ",
      "shippingMode": "Hình thức vận chuyển",
      "techniques": "Kỹ thuật in",
      "warehouse": "Kho"
    }
  },
  "sections": {
    "activityLog": {
      "title": "Nhật ký hoạt động",
      "categoryFilter": {
        "ariaLabel": "Lọc theo danh mục hoạt động",
        "admin_action": "Hành động quản trị",
        "vendor_action": "Hành động nhà cung cấp",
        "system_event": "Sự kiện hệ thống",
        "order_lifecycle": "Vòng đời đơn hàng"
      },
      "loading": "Đang tải hoạt động…",
      "pendingLabel": "Chưa có hoạt động — endpoint đang phát triển.",
      "empty": "Không có hoạt động nào khớp với bộ lọc.",
      "actorPrefix": "Bởi {{actor}}",
      "loadingMore": "Đang tải…",
      "loadMore": "Tải thêm",
      "unknownAction": "Hoạt động",
      "actions": {
        "VENDOR_CREATED": "Đã tạo nhà cung cấp",
        "VENDOR_SUSPENDED": "Đã tạm ngưng nhà cung cấp",
        "VENDOR_REACTIVATED": "Đã kích hoạt lại nhà cung cấp",
        "VENDOR_ACTIVATION_APPROVED": "Đã duyệt kích hoạt nhà cung cấp",
        "VENDOR_ACTIVATION_REJECTED": "Đã từ chối kích hoạt nhà cung cấp",
        "VENDOR_AT_RISK_ACKNOWLEDGED": "Đã ghi nhận cảnh báo rủi ro",
        "VENDOR_BANK_VERIFIED": "Đã xác minh tài khoản ngân hàng",
        "VENDOR_BANK_REJECTED": "Đã từ chối tài khoản ngân hàng",
        "VENDOR_BULK_IMPORT": "Nhập hàng loạt",
        "VENDOR_CAPABILITY_ASSIGNED": "Đã gán năng lực sản xuất",
        "VENDOR_CAPABILITY_PROPOSAL_APPROVED": "Đã duyệt đề xuất năng lực",
        "VENDOR_CAPABILITY_PROPOSAL_REJECTED": "Đã từ chối đề xuất năng lực",
        "VENDOR_COST_APPROVAL_APPROVED": "Đã duyệt thay đổi chi phí",
        "VENDOR_COST_APPROVAL_REJECTED": "Đã từ chối thay đổi chi phí",
        "VENDOR_WALLET_ADJUST_REQUESTED": "Yêu cầu điều chỉnh ví",
        "VENDOR_WALLET_ADJUST_APPLIED": "Đã áp dụng điều chỉnh ví",
        "VENDOR_UPDATED": "Đã cập nhật hồ sơ nhà cung cấp",
        "KYC_DOCUMENT_APPROVED": "Đã duyệt hồ sơ KYC",
        "KYC_DOCUMENT_REJECTED": "Đã từ chối hồ sơ KYC",
        "KYC_DOCUMENT_VIEWED": "Đã xem hồ sơ KYC",
        "AUTH_LOGIN": "Đăng nhập",
        "AUTH_LOGOUT": "Đăng xuất",
        "AUTH_VENDOR_APPROVE": "Đã duyệt đơn đăng ký nhà cung cấp",
        "AUTH_VENDOR_REJECT": "Đã từ chối đơn đăng ký nhà cung cấp",
        "AUTH_VENDOR_REAPPLY": "Nhà cung cấp đăng ký lại",
        "ORDER_ITEM_VENDOR_OVERRIDDEN": "Đã đổi nhà cung cấp cho sản phẩm trong đơn",
        "WITHDRAW_PERMISSION_UPDATED": "Đã cập nhật quyền rút tiền",
        "GDPR_GRANDFATHER_EXPIRED": "Hết thời gian ân hạn đồng ý dữ liệu",
        "AUTH_REFRESH_FAILED": "Làm mới phiên thất bại",
        "AUTH_REFRESH": "Đã làm mới phiên",
        "AUTH_2FA_VERIFY": "Đã xác thực 2 lớp",
        "AUTH_2FA_SETUP": "Đã thiết lập xác thực 2 lớp",
        "AUTH_2FA_DISABLED": "Đã tắt xác thực 2 lớp",
        "AUTH_2FA_CHALLENGE": "Đã gửi yêu cầu xác thực 2 lớp",
        "AUTH_USER_2FA_RESET": "Quản trị viên đặt lại xác thực 2 lớp",
        "AUTH_LOGIN_FAILED": "Đăng nhập thất bại",
        "AUTH_LOGIN_LOCKED": "Khoá tài khoản do đăng nhập sai nhiều lần",
        "AUTH_PASSWORD_CHANGE": "Đã đổi mật khẩu",
        "AUTH_REGISTER": "Đã đăng ký tài khoản",
        "AUTH_PROFILE_UPDATE": "Đã cập nhật hồ sơ",
        "AUTH_BILLING_UPDATE": "Đã cập nhật thông tin thanh toán",
        "AUTH_USER_UPDATE": "Đã cập nhật tài khoản",
        "AUTH_USER_SUSPEND": "Đã tạm khoá tài khoản",
        "AUTH_USER_UNSUSPEND": "Đã mở khoá tài khoản",
        "AUTH_USER_ROLE_GRANT": "Đã cấp vai trò",
        "AUTH_USER_ROLE_REVOKE": "Đã thu hồi vai trò",
        "AUTH_SESSION_REVOKED": "Đã thu hồi phiên đăng nhập",
        "AUTH_IMPERSONATE_START": "Bắt đầu đăng nhập thay người dùng",
        "AUTH_SURVEY_SUBMIT": "Đã gửi khảo sát",
        "AUTH_WS_SUBSCRIBE_DENIED": "Từ chối kết nối thời gian thực",
        "vendor.capacity.current_active_changed": "Đã thay đổi công suất đang hoạt động",
        "vendor.assignment.suspension_cascade": "Đã chuyển đơn phân công sau khi tạm ngưng",
        "payout.approved": "Đã duyệt chi trả",
        "payout.rejected": "Đã từ chối chi trả",
        "payout.mark_transferred": "Đã đánh dấu chuyển tiền",
        "support_ticket.created": "Đã tạo phiếu hỗ trợ",
        "support_ticket.updated": "Đã cập nhật phiếu hỗ trợ",
        "support_ticket.escalated": "Đã chuyển cấp phiếu hỗ trợ",
        "support_ticket_message.created": "Đã trả lời phiếu hỗ trợ",
        "CATEGORY_CREATED": "Đã tạo danh mục",
        "CATEGORY_UPDATED": "Đã cập nhật danh mục",
        "CATEGORY_REORDERED": "Đã sắp xếp lại danh mục",
        "COLLECTION_CREATED": "Đã tạo bộ sưu tập",
        "COLLECTION_UPDATED": "Đã cập nhật bộ sưu tập",
        "COLLECTION_REORDERED": "Đã sắp xếp lại bộ sưu tập",
        "OPTION_CREATED": "Đã tạo tuỳ chọn",
        "OPTION_UPDATED": "Đã cập nhật tuỳ chọn",
        "OPTION_DELETED": "Đã xoá tuỳ chọn",
        "blueprint:create": "Đã tạo blueprint",
        "blueprint:update": "Đã cập nhật blueprint",
        "products_special.create": "Đã tạo sản phẩm đặc biệt",
        "products_special.update_assignments": "Đã cập nhật phân bổ sản phẩm đặc biệt",
        "INVENTORY_STOCK_VIEW": "Đã xem tồn kho",
        "INVENTORY_OVERVIEW_VIEW": "Đã xem tổng quan kho",
        "INVENTORY_REPORT_MOVEMENT_EXPORT": "Đã xuất báo cáo biến động kho",
        "INVENTORY_REPORT_STOCK_LEVEL_EXPORT": "Đã xuất báo cáo mức tồn kho",
        "INVENTORY_REPORT_AGING_EXPORT": "Đã xuất báo cáo tuổi tồn kho",
        "INVENTORY_REPORT_VALUATION_EXPORT": "Đã xuất báo cáo giá trị tồn kho",
        "INVENTORY_REPORT_TURNOVER_EXPORT": "Đã xuất báo cáo vòng quay kho",
        "FRAUD_SETTINGS_UPDATED": "Đã cập nhật cài đặt chống gian lận",
        "ADMIN_ROLE_CREATE": "Đã tạo vai trò quản trị",
        "ADMIN_ROLE_DELETE": "Đã xoá vai trò quản trị",
        "settings.update": "Đã cập nhật cài đặt",
        "EMERGENCY_MODE_ACTIVATED": "Đã bật chế độ khẩn cấp",
        "SYSTEM_BACKUP_TRIGGERED": "Đã kích hoạt sao lưu hệ thống",
        "LEGAL_ENTITY_CREATED": "Đã tạo pháp nhân",
        "merchant_invoice_created": "Đã tạo hoá đơn merchant",
        "invoice_pdf_download": "Đã tải PDF hoá đơn",
        "admin_invoice_pdf_download": "Quản trị viên tải PDF hoá đơn",
        "admin_payment_request_create": "Đã tạo yêu cầu thanh toán",
        "admin_payment_request_pdf_download": "Đã tải PDF yêu cầu thanh toán",
        "billing_address_create": "Đã tạo địa chỉ thanh toán",
        "billing.mode.switched": "Đã chuyển chế độ thanh toán",
        "billing.invoice.manually_generated": "Đã tạo hoá đơn thủ công",
        "billing.refund_task.completed": "Đã hoàn tất tác vụ hoàn tiền"
      },
      "fields": {
        "status": "Trạng thái",
        "activation_status": "Trạng thái kích hoạt",
        "kyc_status": "Trạng thái KYC",
        "reason": "Lý do",
        "rejectReason": "Lý do từ chối",
        "reject_reason": "Lý do từ chối",
        "note": "Ghi chú",
        "tier": "Hạng",
        "vendorTier": "Hạng",
        "amount": "Số tiền",
        "payout_blocked": "Chặn chi trả"
      }
    },
    "capabilities": {
      "title": "Năng lực sản xuất",
      "loading": "Đang tải năng lực…",
      "pendingLabel": "Chưa có năng lực nào — endpoint đang phát triển.",
      "empty": "Chưa có năng lực nào được ghi nhận.",
      "status": {
        "approved": "Đã duyệt",
        "proposed": "Đề xuất",
        "rejected": "Từ chối"
      },
      "productCount": "{{count}} sản phẩm",
      "actions": {
        "approve": "Duyệt",
        "reject": "Từ chối",
        "cancel": "Hủy",
        "confirmReject": "Xác nhận từ chối"
      },
      "rejectReasonLabel": "Lý do từ chối",
      "errors": {
        "reasonRequired": "Vui lòng nhập lý do từ chối.",
        "unknown": "Lỗi không xác định"
      }
    },
    "financial": {
      "title": "Tài chính",
      "costGate": "Thông tin tài chính bị hạn chế. Vai trò của bạn không có quyền xem chi phí tài chính. Hãy liên hệ Super Admin để được cấp quyền.",
      "loading": "Đang tải tài chính…",
      "noData": "Không có dữ liệu tài chính.",
      "subBlocks": {
        "earnings": "Thu nhập",
        "earningsPipeline": "Thu nhập đang xử lý",
        "payouts": "Thanh toán",
        "walletAdjustments": "Điều chỉnh ví",
        "bankAccounts": "Tài khoản ngân hàng"
      },
      "earningsPipelineLabel": "Đang xử lý:",
      "noEarnings": "Không có dữ liệu thu nhập.",
      "noPayouts": "Không có khoản thanh toán nào được lên lịch.",
      "noWalletAdjustments": "Không có điều chỉnh ví nào.",
      "noBankAccounts": "Không có tài khoản ngân hàng nào.",
      "createAdjustment": "+ Tạo điều chỉnh",
      "earningsChartAriaLabel": "Biểu đồ thu nhập",
      "payoutStatus": {
        "paid": "Đã thanh toán",
        "scheduled": "Đã lên lịch",
        "held": "Đang giữ",
        "failed": "Thất bại"
      },
      "defaultBadge": "Mặc định",
      "bankVerifiedBadge": "Đã xác minh",
      "bankPendingBadge": "Chờ xác minh",
      "bankVerify": "Xác minh",
      "bankReview": "Xem lại",
      "columns": {
        "date": "Ngày",
        "amount": "Số tiền",
        "status": "Trạng thái",
        "reference": "Tham chiếu"
      }
    },
    "kyc": {
      "title": "KYC",
      "loading": "Đang tải KYC…",
      "pendingLabel": "Chưa có hồ sơ KYC — endpoint đang phát triển.",
      "noData": "Không có dữ liệu KYC.",
      "payoutsBlockedBanner": {
        "heading": "Thanh toán bị chặn.",
        "body": "Nhà cung cấp chưa KYC vẫn có thể nhận đơn hàng; thanh toán và rút tiền bị chặn cho đến khi KYC được xác minh."
      },
      "docLabels": {
        "business_license": "Giấy phép kinh doanh",
        "tax_certificate": "Chứng chỉ thuế",
        "identity": "Giấy tờ tùy thân (hộ chiếu / CCCD)",
        "bank_proof": "Chứng minh tài khoản ngân hàng"
      },
      "submittedAt": "Đã nộp {{date}}",
      "reviewedAt": "Đã xét duyệt {{date}}",
      "viewDocument": "Xem tài liệu",
      "approve": "Duyệt",
      "reject": "Từ chối",
      "rejectConfirm": "Xác nhận từ chối",
      "cancel": "Huỷ",
      "rejectReasonPlaceholder": "Lý do (tối thiểu 10 ký tự) — gửi cho nhà cung cấp",
      "actionFailed": "Thao tác thất bại — vui lòng thử lại"
    },
    "locations": {
      "title": "Địa điểm",
      "loading": "Đang tải địa điểm…",
      "pendingLabel": "Chưa có địa điểm nào — endpoint đang phát triển.",
      "empty": "Nhà cung cấp này chưa có địa điểm nào.",
      "badge": {
        "primary": "Chính",
        "frozen": "Đã đóng băng"
      },
      "freeze": {
        "working": "Đang xử lý…",
        "unfreeze": "Bỏ đóng băng",
        "freeze": "Đóng băng địa điểm"
      },
      "confirmDialog": {
        "ariaLabel": "Xác nhận đóng băng địa điểm",
        "unfreezePrompt": "Bỏ đóng băng địa điểm này? Các khung năng lực sẽ được mở lại.",
        "freezePrompt": "Đóng băng địa điểm này? Các địa điểm khác không bị ảnh hưởng. Đóng băng nhẹ — đơn hàng hiện tại vẫn tiếp tục.",
        "cancel": "Hủy",
        "confirm": "Xác nhận"
      },
      "errors": {
        "unknown": "Lỗi không xác định"
      }
    },
    "notes": {
      "title": "Ghi chú",
      "subtitle": "Nội bộ — chỉ hiển thị với nhân viên quản trị.",
      "loading": "Đang tải ghi chú…",
      "pendingLabel": "Chưa có ghi chú — endpoint đang phát triển.",
      "empty": "Chưa có ghi chú nội bộ nào.",
      "addNoteLabel": "Thêm ghi chú nội bộ",
      "saving": "Đang lưu…",
      "addNote": "Thêm ghi chú",
      "errors": {
        "unknown": "Lỗi không xác định"
      }
    },
    "pendingCostApprovals": {
      "title": "Yêu cầu duyệt giá đang chờ",
      "loading": "Đang tải đề xuất…",
      "pendingLabel": "Chưa có yêu cầu duyệt giá — endpoint đang phát triển.",
      "empty": "Không có đề xuất thay đổi giá nào đang chờ.",
      "proposed": "Đề xuất {{date}}",
      "proposedBy": "bởi {{name}}",
      "actions": {
        "approve": "Duyệt",
        "reject": "Từ chối",
        "confirmReject": "Xác nhận từ chối"
      },
      "rejectReasonLabel": "Lý do",
      "errors": {
        "reasonRequired": "Vui lòng nhập lý do từ chối.",
        "unknown": "Lỗi không xác định"
      }
    },
    "products": {
      "title": "Sản phẩm",
      "loading": "Đang tải sản phẩm…",
      "pendingLabel": "Chưa có sản phẩm — endpoint đang phát triển.",
      "empty": "Chưa có sản phẩm nào.",
      "columns": {
        "sku": "SKU",
        "product": "Sản phẩm",
        "status": "Trạng thái",
        "cost": "Giá nhập"
      },
      "status": {
        "active": "Hoạt động",
        "pendingReapproval": "Chờ duyệt lại",
        "paused": "Tạm dừng"
      },
      "variantCount": "({{count}} biến thể)",
      "showing": "Hiển thị {{shown}} / {{total}} sản phẩm."
    },
    "recentOrders": {
      "title": "Đơn hàng gần đây",
      "subtitle": "20 đơn hàng gần nhất. Vào trang đơn hàng để xem toàn bộ.",
      "loading": "Đang tải đơn hàng…",
      "pendingLabel": "Chưa có đơn gần đây — endpoint đang phát triển.",
      "empty": "Không có đơn hàng gần đây.",
      "columns": {
        "reference": "Mã đơn",
        "merchant": "Nhà bán hàng",
        "status": "Trạng thái",
        "total": "Tổng",
        "placed": "Ngày đặt"
      },
      "viewAll": "Xem tất cả đơn hàng →"
    },
    "shell": {},
    "slaChart": {
      "title": "Hiệu suất SLA",
      "rangeAriaLabel": "Khoảng thời gian SLA",
      "months": "{{count}} tháng",
      "loading": "Đang tải dữ liệu SLA…",
      "pendingLabel": "Chưa có dữ liệu SLA — endpoint đang phát triển.",
      "empty": "Không có dữ liệu SLA cho khoảng thời gian đã chọn.",
      "chartAriaLabel": "Biểu đồ đường hiệu suất SLA",
      "legend": {
        "fulfilment": "Tỷ lệ hoàn thành",
        "rejection": "Tỷ lệ từ chối"
      }
    },
    "staffAccounts": {
      "title": "Tài khoản nhân viên",
      "subtitle": "Chỉ xem. Tạm ngưng là hành động duy nhất admin có thể thực hiện với nhân viên nhà cung cấp.",
      "loading": "Đang tải nhân viên…",
      "pendingLabel": "Chưa có nhân viên — endpoint đang phát triển.",
      "empty": "Không có tài khoản nhân viên nào.",
      "columns": {
        "name": "Họ tên",
        "email": "Email",
        "role": "Vai trò",
        "status": "Trạng thái",
        "lastLogin": "Đăng nhập cuối",
        "actions": "Hành động"
      },
      "status": {
        "active": "Hoạt động",
        "suspended": "Đã tạm ngưng",
        "pending": "Chờ xử lý"
      },
      "suspending": "Đang tạm ngưng…",
      "suspend": "Tạm ngưng",
      "reactivating": "Đang kích hoạt lại…",
      "reactivate": "Kích hoạt lại",
      "errors": {
        "unknown": "Lỗi không xác định"
      }
    },
    "feedback": {
      "defaultPending": "Tính năng đang phát triển — chưa có dữ liệu."
    }
  },
  "kycQueue": {
    "page": {
      "heading": "Hàng đợi duyệt KYC",
      "subtitle": "Mỗi tài liệu được duyệt riêng lẻ (theo yêu cầu tuân thủ —a). KYC chỉ chặn payout; vendor vẫn nhận đơn bình thường khi chưa duyệt."
    },
    "payoutBanner": {
      "title": "Lưu ý payout:",
      "body": "một hoặc nhiều vendor trong danh sách đang bị chặn rút tiền vì KYC chưa hoàn tất. Vendor vẫn nhận đơn được — chỉ payout/rút tiền bị giữ lại đến khi mọi tài liệu bắt buộc đều được duyệt."
    },
    "tabs": {
      "ariaLabel": "Lọc theo trạng thái",
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "rejected": "Đã từ chối",
      "all": "Tất cả"
    },
    "search": {
      "label": "Tìm kiếm",
      "placeholder": "Tìm vendor hoặc loại tài liệu…"
    },
    "docTypes": {
      "business_license": "Giấy phép kinh doanh",
      "id_card": "CMND/CCCD",
      "tax_cert": "Chứng nhận thuế",
      "bank_proof": "Xác nhận ngân hàng"
    },
    "statusLabels": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "rejected": "Đã từ chối"
    },
    "columns": {
      "vendor": "Vendor",
      "docType": "Loại tài liệu",
      "uploadedAt": "Tải lên",
      "docStatus": "Trạng thái tài liệu",
      "rejectReason": "Lý do từ chối",
      "reviewer": "Reviewer",
      "reviewedAt": "Reviewed at",
      "vendorKyc": "KYC vendor (tổng)",
      "actions": "Hành động"
    },
    "empty": "Không có tài liệu KYC nào khớp bộ lọc hiện tại.",
    "loading": "Đang tải…",
    "payoutBlocked": "Payout chặn",
    "actions": {
      "viewAndReview": "Xem & duyệt",
      "loadMore": "Tải thêm"
    },
    "toast": {
      "accessLogTitle": "Nhật ký truy cập",
      "accessLogFail": "Không tải được nhật ký truy cập",
      "listFail": "Không tải được danh sách KYC",
      "approvedTitle": "Đã duyệt tài liệu KYC",
      "approveFail": "Không thể duyệt tài liệu KYC",
      "rejectedTitle": "Đã từ chối tài liệu KYC",
      "rejectFail": "Không thể từ chối tài liệu KYC",
      "errorTitle": "Lỗi"
    }
  },
  "kycViewer": {
    "ariaLabel": "Trình xem tài liệu KYC",
    "docTypes": {
      "business_license": "Giấy phép kinh doanh",
      "id_card": "CMND/CCCD",
      "tax_cert": "Chứng nhận thuế",
      "bank_proof": "Xác nhận ngân hàng"
    },
    "statusLabels": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "rejected": "Đã từ chối"
    },
    "description": {
      "email": "Email: {{email}}",
      "uploadedAt": "Tải lên {{date}}",
      "fileSize": "Kích thước {{size}}"
    },
    "statusRow": {
      "docStatus": "Trạng thái tài liệu:",
      "vendorKyc": "KYC vendor:",
      "payoutBlocked": "Payout bị chặn",
      "payoutOpen": "Payout mở"
    },
    "accessLog": {
      "title": "Cảnh báo truy cập:",
      "body": "tài liệu này đã được mở {{count}} lần gần đây. Đảm bảo bạn đang xem vì lý do chính đáng — mọi lần mở đều được ghi vào nhật ký kiểm tra (audit log)."
    },
    "media": {
      "loading": "Đang tải tài liệu…",
      "unsupported": "Loại file không hỗ trợ xem trực tiếp.",
      "download": "Tải xuống ({{name}})",
      "docAlt": "Tài liệu KYC",
      "pdfTitle": "Tài liệu KYC PDF"
    },
    "review": {
      "approved": "Đã duyệt bởi {{reviewer}}",
      "rejected": "Đã từ chối bởi {{reviewer}}",
      "at": "Vào lúc {{date}}",
      "rejectReasonLabel": "Lý do từ chối:"
    },
    "rejectForm": {
      "label": "Lý do từ chối (bắt buộc, ≥ {{min}} ký tự)",
      "placeholder": "Nêu rõ lý do từ chối để vendor có thể nộp lại đúng…",
      "charCount": "{{count}}/{{max}} ký tự",
      "tooShort": "Cần tối thiểu {{min}} ký tự",
      "valid": "Hợp lệ"
    },
    "buttons": {
      "close": "Đóng",
      "cancelReject": "Huỷ từ chối",
      "processing": "Đang xử lý…",
      "confirmReject": "Xác nhận từ chối",
      "reject": "Từ chối",
      "approve": "Duyệt"
    }
  },
  "pendingVendors": {
    "page": {
      "heading": "Đơn đăng ký Vendor đang chờ",
      "subtitle": "Xem xét câu trả lời khảo sát và phê duyệt hoặc từ chối. AC-13."
    },
    "columns": {
      "vendor": "Vendor",
      "email": "Email",
      "country": "Quốc gia",
      "applied": "Ngày đăng ký",
      "survey": "Khảo sát",
      "surveyPending": "Chờ xử lý"
    },
    "search": {
      "placeholder": "Tìm vendor…"
    },
    "empty": "Không có đơn đăng ký vendor nào đang chờ.",
    "toast": {
      "loadFailTitle": "Không thể tải danh sách vendor chờ duyệt",
      "networkError": "Lỗi mạng",
      "unknownError": "Lỗi không xác định"
    }
  },
  "pendingCapabilities": {
    "noLabel": "(không có nhãn)",
    "heading": "Đề xuất capability chờ duyệt",
    "badgeAriaLabel": "{{total}} đề xuất chờ duyệt",
    "subtitle": "Tổng hợp các đề xuất capability từ mọi vendor. Cập nhật tự động mỗi 30 giây.",
    "columns": {
      "vendor": "Vendor",
      "capability": "Capability đề xuất",
      "type": "Loại",
      "proposedAt": "Đề xuất lúc",
      "actions": "Hành động"
    },
    "loading": "Đang tải danh sách…",
    "empty": "Không có đề xuất capability nào đang chờ",
    "actions": {
      "refresh": "Làm mới",
      "refreshing": "Đang tải…",
      "review": "Xem xét"
    },
    "toast": {
      "approved": "Đã phê duyệt đề xuất capability",
      "rejected": "Đã từ chối đề xuất capability"
    }
  },
  "createWizard": {
    "stepperAriaLabel": "Tiến độ tạo vendor",
    "steps": {
      "basic": "Thông tin cơ bản",
      "location_capabilities": "Vị trí & năng lực",
      "config": "Cấu hình"
    },
    "heading": "Tạo vendor mới",
    "subheading": "Wizard 3 bước. Sau khi tạo, vendor ở trạng thái Pending Activation và phải được admin approve trước khi nhận đơn.",
    "progressTitle": "Tiến độ",
    "toast": {
      "created": {
        "title": "Đã tạo vendor",
        "description": "Vendor đang ở trạng thái Pending Activation. Vào danh sách để approve activation."
      },
      "error": {
        "title": "Không tạo được vendor",
        "fallback": "Tạo vendor thất bại.",
        "unknownHttp": "Lỗi không xác định (HTTP {{status}})."
      },
      "networkError": {
        "title": "Lỗi mạng",
        "fallback": "Không kết nối được tới máy chủ."
      }
    }
  },
  "createSteps": {
    "validation": {
      "businessNameMin": "Tên doanh nghiệp phải có ít nhất 2 ký tự",
      "max120": "Tối đa 120 ký tự",
      "legalNameMin": "Tên pháp lý phải có ít nhất 2 ký tự",
      "max160": "Tối đa 160 ký tự",
      "emailInvalid": "Email không hợp lệ",
      "emailTooLong": "Email quá dài",
      "phoneMin": "Số điện thoại phải có ít nhất 6 chữ số",
      "phoneTooLong": "Số điện thoại quá dài",
      "countryIsoExample": "Mã quốc gia ISO 2 ký tự (ví dụ: VN, US)",
      "countryUppercase": "Mã quốc gia phải viết hoa",
      "timezoneInvalid": "Múi giờ không hợp lệ",
      "timezoneTooLong": "Múi giờ quá dài",
      "timezoneIana": "Định dạng IANA (vd: Asia/Ho_Chi_Minh)",
      "locationLabelMin": "Nhãn vị trí tối thiểu 2 ký tự",
      "addressMin": "Địa chỉ tối thiểu 2 ký tự",
      "cityRequired": "Thành phố không được trống",
      "countryIso": "Mã quốc gia ISO 2 ký tự",
      "mustBeInteger": "Phải là số nguyên",
      "capacityMax": "Tối đa 100,000 đơn / ngày",
      "pctRange": "Phần trăm trong khoảng 0-100",
      "capabilitiesMax": "Tối đa 50 năng lực",
      "warningLteCritical": "Cảnh báo (%) phải <= Nguy hiểm (%)",
      "surchargeMax": "Tối đa 10,000 bps (100%)",
      "notesMax": "Ghi chú tối đa 2000 ký tự"
    },
    "basicInfo": {
      "heading": "Bước 1 — Thông tin cơ bản",
      "description": "Thông tin liên hệ và định danh pháp lý của vendor (vendor profile chính).",
      "fields": {
        "businessName": "Tên doanh nghiệp (hiển thị)",
        "legalName": "Tên pháp lý",
        "email": "Email liên hệ",
        "phone": "Số điện thoại",
        "country": "Mã quốc gia (ISO-2)",
        "timezone": "Múi giờ (IANA)",
        "language": "Ngôn ngữ vendor"
      },
      "languageOptions": {
        "vi": "Tiếng Việt",
        "en": "English"
      },
      "actions": {
        "cancel": "Huỷ",
        "next": "Tiếp tục"
      },
      "timezonePlaceholder": "Asia/Ho_Chi_Minh"
    },
    "config": {
      "heading": "Bước 3 — Cấu hình & xác nhận",
      "description": "Cấu hình tier chất lượng và phụ phí. Sau khi tạo, vendor sẽ ở trạng thái Pending Activation — chưa nhận đơn cho tới khi admin approve.",
      "review": {
        "title": "Xem lại thông tin đã nhập",
        "businessName": "Tên doanh nghiệp",
        "legalName": "Tên pháp lý",
        "email": "Email",
        "phone": "Điện thoại",
        "countryTimezone": "Quốc gia / Múi giờ",
        "language": "Ngôn ngữ",
        "capacity": "Capacity",
        "capabilities": "Năng lực",
        "firstLocation": "Kho đầu tiên",
        "noCapabilities": "Chưa chọn",
        "capacityDisplay": "{{capacity}} đơn/ngày — cảnh báo {{warning}}%, nguy hiểm {{critical}}%"
      },
      "fields": {
        "qualityTier": "Quality tier",
        "surchargeBps": "Phụ phí (basis points — 100 bps = 1%)",
        "holdPeriodTier": "Chu kỳ giữ payout",
        "notes": "Ghi chú (tuỳ chọn)"
      },
      "qualityTierOptions": {
        "standard": "Standard",
        "preferred": "Preferred",
        "premium": "Premium"
      },
      "holdPeriodOptions": {
        "7d": "7 ngày",
        "14d": "14 ngày",
        "30d": "30 ngày"
      },
      "actions": {
        "back": "Quay lại",
        "creating": "Đang tạo…",
        "create": "Tạo vendor"
      }
    },
    "locationCapabilities": {
      "heading": "Bước 2 — Vị trí & năng lực",
      "description": "Kho đầu tiên, hạn mức công suất và danh sách năng lực in. Sau khi vendor active, có thể bổ sung kho qua trang chi tiết.",
      "capacity": {
        "title": "Hạn mức công suất",
        "globalLabel": "Tổng đơn / ngày",
        "maxConcurrentLabel": "Đơn đang xử lý đồng thời tối đa",
        "warningPctLabel": "Ngưỡng cảnh báo (%)",
        "criticalPctLabel": "Ngưỡng nguy hiểm (%)"
      },
      "capabilities": {
        "title": "Năng lực in & vận chuyển",
        "label": "Năng lực in (chọn nhiều)",
        "groupAriaLabel": "Năng lực in",
        "loading": "Đang tải danh sách kỹ thuật…",
        "loadError": "Không tải được danh sách kỹ thuật.",
        "retry": "Thử lại"
      },
      "shippingMode": {
        "label": "Phương thức ship",
        "options": {
          "hybrid": "Hybrid",
          "self_ship": "Tự ship",
          "printway_processed": "Processed by Printway"
        }
      },
      "location": {
        "title": "Kho đầu tiên",
        "labelField": "Tên kho",
        "address1": "Địa chỉ dòng 1",
        "address2": "Địa chỉ dòng 2 (tuỳ chọn)",
        "city": "Thành phố",
        "region": "Tỉnh/Bang (tuỳ chọn)",
        "postal": "Mã ZIP (tuỳ chọn)",
        "country": "Quốc gia (ISO-2)"
      },
      "actions": {
        "back": "Quay lại",
        "next": "Tiếp tục"
      }
    }
  },
  "edit": {
    "heading": "Chỉnh sửa vendor",
    "subheading": "Đang chỉnh sửa {{name}} · mọi thay đổi được ghi vào nhật ký kiểm tra.",
    "savedAt": "Đã lưu · {{time}}",
    "loading": "Đang tải vendor để chỉnh sửa…",
    "errors": {
      "missingVendorId": "Thiếu vendor id trong đường dẫn.",
      "noPermission": "Bạn không có quyền chỉnh sửa vendor.",
      "loadFailed": "Tải vendor thất bại: {{message}}"
    },
    "fields": {
      "name": "Tên vendor",
      "legalName": "Tên pháp lý",
      "email": "Email",
      "phone": "Điện thoại",
      "primaryContact": "Liên hệ chính",
      "country": "Quốc gia",
      "tier": "Tier"
    },
    "reasonLabel": "Lý do thay đổi (bắt buộc, tối thiểu 10 ký tự)",
    "validation": {
      "nameRequired": "Tên vendor là bắt buộc.",
      "reasonRequired": "Lý do thay đổi là bắt buộc (tối thiểu 10 ký tự)."
    },
    "dirty": {
      "changed": "{{count}} trường đã thay đổi",
      "noPending": "Chưa có thay đổi"
    },
    "actions": {
      "cancel": "Huỷ",
      "back": "Quay lại nhà cung cấp",
      "save": "Lưu thay đổi",
      "saving": "Đang lưu…"
    },
    "cancelDialog": {
      "title": "Bỏ thay đổi chưa lưu?",
      "description": "Form đang có thay đổi chưa lưu. Tiếp tục huỷ sẽ mất các thay đổi này.",
      "keepEditing": "Quay lại form",
      "discard": "Huỷ và bỏ thay đổi"
    }
  },
  "productDetail": {
    "backLink": "← Quay lại Vendor",
    "loading": "Đang tải sản phẩm…",
    "errors": {
      "notFound": "Không tìm thấy sản phẩm (sai vendor hoặc product id).",
      "loadFailed": "Lỗi tải sản phẩm: {{message}}"
    },
    "noName": "(không tên)",
    "fields": {
      "baseCost": "Giá gốc",
      "submission": "Phương thức gửi",
      "blueprint": "Blueprint"
    },
    "openBlueprint": "Mở blueprint →",
    "rejectReason": "Lý do từ chối: {{reason}}",
    "variantsTitle": "Variants ({{count}})",
    "noVariants": "Chưa có variant.",
    "variantColumns": {
      "sku": "SKU",
      "size": "Kích cỡ",
      "color": "Màu",
      "markup": "Markup",
      "price": "Giá",
      "externalSku": "External SKU"
    },
    "approvalHistory": {
      "title": "Lịch sử phê duyệt",
      "events": "{{count}} sự kiện",
      "lastEventSuffix": " · gần nhất: {{event}}",
      "lastEventAt": "Thời điểm gần nhất: {{when}}"
    }
  },
  "bulkImport": {
    "page": {
      "heading": "Nhập hàng loạt nhà cung cấp",
      "subtitle": "Tải lên file CSV để tạo nhiều nhà cung cấp cùng lúc. Tất cả nhà cung cấp được nhập sẽ ở trạng thái Chờ Kích Hoạt và cần quản trị viên phê duyệt để kích hoạt."
    },
    "nav": {
      "ariaLabel": "Tiến trình trình hướng dẫn"
    },
    "stepLabels": {
      "upload": "Tải lên",
      "mapColumns": "Ánh xạ cột",
      "preview": "Xem trước",
      "commit": "Xác nhận"
    },
    "toast": {
      "importFinished": "Nhập hoàn tất",
      "importFinishedDesc": "{{count}} nhà cung cấp đã được tạo và đang chờ kích hoạt.",
      "commitFailed": "Xác nhận thất bại",
      "unknownError": "Lỗi không xác định"
    },
    "error": {
      "missingParseTitle": "Thiếu kết quả phân tích",
      "missingParseDesc": "Vui lòng tải lại file CSV.",
      "missingValidateTitle": "Thiếu kết quả xác thực",
      "missingValidateDesc": "Vui lòng chạy lại xác thực.",
      "noCommitTitle": "Không có kết quả xác nhận",
      "noCommitDesc": "Vui lòng bắt đầu lại quá trình nhập.",
      "startOver": "Bắt đầu lại"
    }
  },
  "csvSteps": {
    "upload": {
      "heading": "Bước 1 — Tải lên CSV",
      "subtitle": "Thả file CSV vào đây hoặc nhấn \"Chọn file\". Dung lượng tối đa 5 MB.",
      "dragHere": "Kéo file CSV vào đây",
      "selected": "Đã chọn: {{name}}",
      "btn": {
        "uploading": "Đang tải lên…",
        "browse": "Chọn file",
        "downloadTemplate": "Tải mẫu CSV"
      },
      "hint": {
        "before": "Các cột bắt buộc: name, email, phone, country (mã 2 ký tự ISO). Tùy chọn: displayName, language, timezone. Ô bắt đầu bằng",
        "orConnector": "hoặc",
        "after": "sẽ bị loại bỏ ký tự đầu tiên (bảo vệ khỏi CSV-injection)."
      },
      "toast": {
        "emptyTitle": "File CSV trống",
        "emptyDesc": "Vui lòng chọn file có ít nhất một hàng dữ liệu.",
        "tooLargeTitle": "File CSV quá lớn",
        "tooLargeDesc": "File phải nhỏ hơn hoặc bằng 5 MB. File của bạn có dung lượng {{size}} MB.",
        "badTypeTitle": "Loại file không được hỗ trợ",
        "badTypeDesc": "Vui lòng chọn file có định dạng .csv.",
        "parseFailTitle": "Không thể phân tích file CSV",
        "unknownError": "Lỗi không xác định"
      }
    },
    "mapping": {
      "heading": "Bước 2 — Ánh xạ cột",
      "subtitle": "Ghép từng cột CSV với trường nhà cung cấp. Các trường bắt buộc: {{fields}}.",
      "skipColumn": "Bỏ qua cột",
      "fieldLabels": {
        "name": "Tên (bắt buộc)",
        "email": "Email (bắt buộc)",
        "phone": "Số điện thoại (bắt buộc)",
        "country": "Quốc gia (bắt buộc)",
        "displayName": "Tên hiển thị",
        "language": "Ngôn ngữ",
        "timezone": "Múi giờ"
      },
      "table": {
        "csvColumn": "Cột CSV",
        "sampleValues": "Giá trị mẫu",
        "mapToField": "Ánh xạ tới trường",
        "emptyHeader": "(trống)",
        "noPreview": "(không có xem trước)"
      },
      "validation": {
        "missingRequired": "Thiếu ánh xạ cho trường bắt buộc: {{fields}}",
        "duplicates": "Mỗi trường chỉ được ánh xạ một lần. Trùng lặp: {{fields}}"
      },
      "btn": {
        "back": "Quay lại",
        "validate": "Xác thực",
        "validating": "Đang xác thực…"
      },
      "toast": {
        "validationFailed": "Xác thực thất bại",
        "unknownError": "Lỗi không xác định"
      }
    },
    "preview": {
      "heading": "Bước 3 — Xem trước & Xác thực",
      "subtitle": "Kết quả chạy thử. Sửa các lỗi bằng cách quay lại chỉnh sửa ánh xạ hoặc file CSV gốc; sau đó tiến hành xác nhận.",
      "stats": {
        "totalRows": "Tổng số hàng",
        "valid": "Hợp lệ",
        "invalid": "Không hợp lệ"
      },
      "truncatedNotice": "Đang hiển thị {{shown}} lỗi đầu tiên. Tổng số lỗi là {{total}}. Tải xuống báo cáo lỗi để xem chi tiết.",
      "noIssues": "Không phát hiện lỗi. {{count}} hàng sẵn sàng để nhập.",
      "table": {
        "rowNum": "Hàng #",
        "issues": "Lỗi"
      },
      "btn": {
        "back": "Quay lại",
        "downloadErrorReport": "Tải báo cáo lỗi",
        "importing": "Đang nhập…",
        "import": "Nhập {{count}} hàng hợp lệ"
      },
      "errorReportTruncatedComment": "# Đã cắt bớt — danh sách giới hạn {{shown}} lỗi đầu tiên; tổng số hàng không hợp lệ: {{total}}"
    },
    "commit": {
      "heading": "Bước 4 — Nhập hoàn tất",
      "subtitleOk": "Tất cả các hàng hợp lệ đã được nhập. Mỗi nhà cung cấp mới ở trạng thái Chờ Kích Hoạt; hãy xem xét chúng trong hàng chờ phê duyệt nhà cung cấp.",
      "subtitlePartial": "Nhập hoàn tất với kết quả một phần — xem bên dưới.",
      "stats": {
        "totalRows": "Tổng số hàng",
        "inserted": "Đã chèn",
        "skipped": "Đã bỏ qua",
        "errors": "Lỗi"
      },
      "skippedReason": "bỏ qua — email đã tồn tại hoặc chèn thất bại",
      "skippedRows": {
        "prefix": "Các hàng bị bỏ qua:",
        "more": " và {{count}} hàng khác",
        "hint": "Nguyên nhân phổ biến: email đã tồn tại trong cơ sở dữ liệu. Tải xuống báo cáo hàng bị bỏ qua để phân tích thủ công."
      },
      "btn": {
        "downloadSkipped": "Tải báo cáo hàng bị bỏ qua",
        "startAnother": "Bắt đầu nhập khác",
        "done": "Hoàn tất"
      }
    }
  },
  "costApproval": {
    "queue": {
      "page": {
        "heading": "Hàng đợi duyệt giá vendor",
        "description": "Vendor đề xuất giá sản xuất / mùa vụ / phụ phí từ portal; admin duyệt hoặc từ chối tại đây. Giá cũ vẫn áp dụng cho đến khi đề xuất mới được duyệt. Mỗi hành động đều được ghi vào nhật ký kiểm toán."
      },
      "tabs": {
        "pending": "Đang chờ",
        "approved": "Đã duyệt",
        "rejected": "Đã từ chối",
        "all": "Tất cả"
      },
      "tablist": {
        "ariaLabel": "Lọc theo trạng thái"
      },
      "filter": {
        "costTypeLabel": "Loại chi phí",
        "allCostTypes": "Tất cả loại chi phí"
      },
      "costTypeLabels": {
        "production": "Production",
        "seasonal": "Seasonal",
        "surcharge": "Surcharge"
      },
      "vendorFilter": {
        "prefix": "Đang lọc theo vendor:",
        "clear": "Xoá bộ lọc"
      },
      "columns": {
        "vendor": "Vendor",
        "variant": "Variant",
        "type": "Loại",
        "current": "Hiện tại",
        "proposed": "Đề xuất",
        "delta": "Δ%",
        "proposedBy": "Người đề xuất",
        "submittedAt": "Gửi lúc",
        "actionsHeader": "Hành động",
        "statusHeader": "Trạng thái"
      },
      "loading": "Đang tải…",
      "empty": "Không có đề xuất giá nào trong bộ lọc hiện tại.",
      "statusLabels": {
        "pending": "Đang chờ",
        "approved": "Đã duyệt",
        "rejected": "Đã từ chối"
      },
      "toast": {
        "approveSuccess": "Đã duyệt đề xuất giá vendor",
        "rejectSuccess": "Đã từ chối đề xuất giá vendor",
        "errorTitle": "Lỗi"
      },
      "errors": {
        "loadFailed": "Không tải được hàng đợi duyệt giá",
        "approveFailed": "Không thể duyệt đề xuất",
        "rejectFailed": "Không thể từ chối đề xuất"
      }
    },
    "detail": {
      "title": "Xem xét đề xuất giá vendor",
      "closeAriaLabel": "Đóng cửa sổ",
      "costTypeLabels": {
        "production": "Production (giá sản xuất)",
        "seasonal": "Seasonal (phụ phí mùa vụ)",
        "surcharge": "Surcharge (phụ phí thao tác)"
      },
      "meta": {
        "costType": "Loại chi phí",
        "proposedBy": "Người đề xuất",
        "submittedAt": "Gửi lúc",
        "status": "Trạng thái"
      },
      "statusText": {
        "pending": "Đang chờ duyệt",
        "approved": "Đã duyệt · {{reviewedAt}}",
        "rejected": "Đã từ chối · {{reviewedAt}}"
      },
      "diff": {
        "ariaLabel": "So sánh giá hiện tại và giá đề xuất",
        "currentLabel": "Giá hiện tại (live)",
        "noCurrent": "(chưa có)",
        "proposedLabel": "Giá đề xuất (mới)",
        "deltaLabel": "Chênh lệch:"
      },
      "savedRejectReason": "Lý do từ chối đã lưu:",
      "rejectForm": {
        "label": "Lý do từ chối",
        "placeholder": "Nêu rõ lý do để vendor có thể chỉnh sửa và gửi lại đề xuất khác.",
        "minHint": "Tối thiểu {{min}} ký tự.",
        "tooShortError": "Lý do từ chối phải có ít nhất {{min}} ký tự (hiện tại: {{current}})."
      },
      "actions": {
        "close": "Đóng",
        "reject": "Từ chối",
        "approve": "Duyệt",
        "approving": "Đang xử lý…",
        "back": "Quay lại",
        "submitting": "Đang gửi…",
        "confirmReject": "Xác nhận từ chối"
      }
    },
    "rowActions": {
      "statusLabels": {
        "approved": "Đã duyệt",
        "rejected": "Đã từ chối",
        "pending": "Đang chờ"
      },
      "approveButton": "Duyệt",
      "rejectButton": "Từ chối",
      "approveAriaLabel": "Duyệt đề xuất giá vendor",
      "rejectAriaLabel": "Từ chối đề xuất giá vendor"
    }
  },
  "modals": {
    "activationApprove": {
      "title": "Phê duyệt kích hoạt vendor",
      "descWithName": "Vendor <strong>{{name}}</strong> sẽ chuyển sang trạng thái <strong>Active</strong> và nhận email kích hoạt.",
      "descGeneric": "Vendor sẽ chuyển sang trạng thái <strong>Active</strong> và nhận email kích hoạt.",
      "noteLabel": "Ghi chú (tùy chọn)",
      "notePlaceholder": "Lý do hoặc ghi chú nội bộ — không gửi cho vendor",
      "cancel": "Hủy",
      "submittingLabel": "Đang phê duyệt…",
      "submit": "Phê duyệt",
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    },
    "activationReject": {
      "title": "Từ chối kích hoạt vendor",
      "descWithName": "Vendor <strong>{{name}}</strong> sẽ chuyển sang trạng thái <strong>Rejected</strong> và nhận email kèm lý do.",
      "descGeneric": "Vendor sẽ chuyển sang trạng thái <strong>Rejected</strong> và nhận email kèm lý do.",
      "reasonLabel": "Lý do từ chối",
      "reasonPlaceholder": "Nhập lý do (tối thiểu {{min}} ký tự)…",
      "remaining": "Cần thêm {{count}} ký tự",
      "valid": "Đủ điều kiện",
      "cancel": "Hủy",
      "submittingLabel": "Đang xử lý…",
      "submit": "Từ chối",
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    },
    "atRiskAcknowledge": {
      "title": "Xác nhận đã xem At-Risk flag",
      "descWithNameAndVendor": "Cờ <strong>{{flag}}</strong> trên vendor <strong>{{name}}</strong> sẽ được đánh dấu đã xem. Trạng thái vendor không thay đổi — bạn vẫn cần quyết định riêng (suspend / warn / keep).",
      "descGenericWithFlag": "Cờ <strong>{{flag}}</strong> sẽ được đánh dấu đã xem. Trạng thái vendor không thay đổi.",
      "metricsHeading": "Chỉ số tham khảo",
      "metricRatingAvg": "Rating trung bình",
      "metricSampleSize": "Số đơn mẫu",
      "metricRejectRate": "Tỷ lệ từ chối",
      "metricComplaintCount": "Số khiếu nại",
      "metricWindowHours": "Cửa sổ thời gian",
      "flagLabels": {
        "low_rating": "Đánh giá thấp (Low Rating)",
        "high_rejection": "Tỷ lệ từ chối cao (High Rejection)",
        "complaint_spike": "Tăng đột biến khiếu nại (Complaint Spike)"
      },
      "noteLabel": "Ghi chú (tùy chọn)",
      "notePlaceholder": "Lý do hoặc quyết định nội bộ — không gửi cho vendor",
      "cancel": "Hủy",
      "submittingLabel": "Đang ghi nhận…",
      "submit": "Xác nhận đã xem",
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    },
    "bankAccountVerify": {
      "title": "Xác minh tài khoản ngân hàng vendor",
      "descWithName": "Xem xét thông tin tài khoản ngân hàng do vendor <strong>{{name}}</strong> đăng ký.",
      "descGeneric": "Xem xét thông tin tài khoản ngân hàng do vendor đăng ký.",
      "fieldMethod": "Phương thức",
      "fieldHolder": "Chủ tài khoản",
      "fieldNumber": "Số tài khoản",
      "fieldBank": "Ngân hàng",
      "fieldSwift": "SWIFT",
      "fieldStatus": "Trạng thái",
      "statusVerified": "Đã xác minh",
      "statusPending": "Chờ xác minh",
      "alreadyVerifiedNotice": "Tài khoản này đã được xác minh trước đó. Không cần thao tác thêm.",
      "decisionAriaLabel": "Quyết định",
      "decisionVerify": "Xác minh",
      "decisionReject": "Từ chối",
      "reasonLabel": "Lý do từ chối",
      "reasonPlaceholder": "Nhập lý do (tối thiểu {{min}} ký tự)…",
      "remaining": "Cần thêm {{count}} ký tự",
      "valid": "Đủ điều kiện",
      "verifyNote": "Xác minh không phát hành thanh toán ngay. Vendor vẫn phải đạt trạng thái KYC đã duyệt để mở khóa rút tiền.",
      "close": "Đóng",
      "cancel": "Hủy",
      "submittingLabel": "Đang xử lý…",
      "submitVerify": "Xác minh",
      "submitReject": "Từ chối",
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    },
    "capabilityAssign": {
      "title": "Gán capability cho vendor",
      "descWithName": "Gán capability mới cho vendor <strong>{{name}}</strong>. Capability sẽ áp dụng ngay (không cần vendor xác nhận).",
      "descGeneric": "Gán capability mới cho vendor. Capability sẽ áp dụng ngay (không cần vendor xác nhận).",
      "capabilityLabel": "Capability",
      "selectAllAssigned": "— Vendor đã có tất cả capability trong catalog —",
      "selectPlaceholder": "— Chọn capability —",
      "processingLabel": "Processing time (ngày)",
      "processingHint": "{{min}}…{{max}} ngày",
      "capacityLabel": "Capacity / ngày",
      "capacityHint": "{{min}}…{{max}} đơn",
      "baseCostLabel": "Base cost (cents)",
      "baseCostHint": "{{min}}…{{max}} cents",
      "cancel": "Hủy",
      "submittingLabel": "Đang gán…",
      "submit": "Gán capability",
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    },
    "capabilityProposal": {
      "title": "Xem xét đề xuất capability",
      "descWithNameAndBlueprint": "Vendor <strong>{{name}}</strong> đề xuất capability cho blueprint <strong>{{blueprint}}</strong>.",
      "descWithName": "Vendor <strong>{{name}}</strong> đề xuất capability.",
      "descGeneric": "Đề xuất capability từ vendor đang chờ phê duyệt.",
      "proposalContentLabel": "Nội dung đề xuất",
      "decisionAriaLabel": "Quyết định",
      "decisionApprove": "Phê duyệt",
      "decisionReject": "Từ chối",
      "reasonLabel": "Lý do từ chối",
      "reasonPlaceholder": "Nhập lý do (tối thiểu {{min}} ký tự)…",
      "remaining": "Cần thêm {{count}} ký tự",
      "valid": "Đủ điều kiện",
      "cancel": "Hủy",
      "submittingLabel": "Đang xử lý…",
      "submitApprove": "Phê duyệt",
      "submitReject": "Từ chối",
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    },
    "vendorReactivate": {
      "title": "Kích hoạt lại vendor",
      "descWithName": "Vendor <strong>{{name}}</strong> sẽ được khôi phục về trạng thái <strong>Active</strong>. Payouts (chi trả) được mở khóa và vendor có thể nhận đơn trở lại.",
      "descGeneric": "Vendor sẽ được khôi phục về trạng thái <strong>Active</strong>. Payouts (chi trả) được mở khóa và vendor có thể nhận đơn trở lại.",
      "reasonLabel": "Lý do kích hoạt lại (tùy chọn)",
      "reasonPlaceholder": "Ghi chú nội bộ về lý do kích hoạt lại — không bắt buộc",
      "cancel": "Hủy",
      "submittingLabel": "Đang kích hoạt…",
      "submit": "Kích hoạt lại",
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    },
    "vendorSuspend": {
      "title": "Tạm dừng vendor",
      "descWithName": "Vendor <strong>{{name}}</strong> sẽ bị tạm dừng. Payouts (chi trả) sẽ bị khóa và đơn đang chờ sẽ tạm dừng cho đến khi vendor được kích hoạt lại.",
      "descGeneric": "Vendor sẽ bị tạm dừng. Payouts (chi trả) sẽ bị khóa và đơn đang chờ sẽ tạm dừng cho đến khi vendor được kích hoạt lại.",
      "tierHoldPeriodPrefix": "Hold-period (thời gian khóa):",
      "tier1Label": "7 ngày",
      "tier1Desc": "Điểm đánh giá từ 0.8 trở lên nên thời gian tạm ngưng là 7 ngày kể từ bây giờ.",
      "tier2Label": "14 ngày",
      "tier2Desc": "Điểm đánh giá trong khoảng 0.5–0.79 (hoặc chưa được chấm điểm) nên thời gian tạm ngưng là 14 ngày kể từ bây giờ.",
      "reasonLabel": "Lý do tạm dừng",
      "reasonPlaceholder": "Nhập lý do (tối thiểu {{min}} ký tự)…",
      "remaining": "Cần thêm {{count}} ký tự",
      "valid": "Đủ điều kiện",
      "cancel": "Hủy",
      "submittingLabel": "Đang tạm dừng…",
      "submit": "Tạm dừng vendor",
      "networkError": "Lỗi mạng — kiểm tra kết nối",
      "tier3Label": "21 ngày",
      "tier3Desc": "Điểm đánh giá dưới 0.5 nên thời gian tạm ngưng là 21 ngày kể từ bây giờ."
    },
    "walletHoldRelease": {
      "holdTitle": "Tạm khoá ví vendor",
      "holdDescWithName": "Ví của vendor <strong>{{name}}</strong> sẽ bị tạm khoá. Vendor không thể rút tiền hay tạo payout mới đến khi được mở lại.",
      "holdDescGeneric": "Ví của vendor sẽ bị tạm khoá. Vendor không thể rút tiền hay tạo payout mới đến khi được mở lại.",
      "holdSubmit": "Khoá ví",
      "holdSubmitting": "Đang khoá…",
      "releaseTitle": "Mở khoá ví vendor",
      "releaseDescWithName": "Ví của vendor <strong>{{name}}</strong> sẽ được mở lại. Vendor có thể tạo payout / rút tiền như bình thường.",
      "releaseDescGeneric": "Ví của vendor sẽ được mở lại. Vendor có thể tạo payout / rút tiền như bình thường.",
      "releaseSubmit": "Mở ví",
      "releaseSubmitting": "Đang mở khoá…",
      "reasonLabel": "Lý do",
      "reasonMinHint": "(tối thiểu {{min}} ký tự)",
      "holdPlaceholder": "Lý do khoá ví — ghi audit, không gửi cho vendor",
      "releasePlaceholder": "Lý do mở ví — ghi audit, không gửi cho vendor",
      "remaining": "Cần thêm {{count}} ký tự",
      "cancel": "Hủy",
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    },
    "walletAdjustment": {
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    }
  },
  "settings": {
    "title": "Cài đặt Vendor",
    "subtitle": "Cấu hình phân bổ và định tuyến cấp vendor.",
    "tablistAria": "Các tab cài đặt vendor",
    "tabs": {
      "mapping": "Định tuyến"
    }
  },
  "catalog": {
    "pageTitle": "Nhà cung cấp",
    "pageSubtitle": "Quản lý đối tác cung cấp, thông tin nhà cung cấp và năng lực sản xuất.",
    "searchPlaceholder": "Tìm nhà cung cấp...",
    "statusAll": "Trạng thái: Tất cả",
    "statusActive": "Trạng thái: Đang hoạt động",
    "statusInactive": "Trạng thái: Ngừng hoạt động",
    "create": "Tạo mới",
    "colName": "Tên",
    "colCode": "Mã",
    "colLocation": "Khu vực",
    "colCreatedDate": "Ngày tạo",
    "colLastUpdate": "Cập nhật lần cuối",
    "colCreator": "Người tạo",
    "colLastEditor": "Sửa lần cuối bởi",
    "colStatus": "Trạng thái",
    "colActions": "Hành động",
    "loading": "Đang tải danh sách nhà cung cấp…",
    "loadError": "Không tải được danh sách nhà cung cấp.",
    "retry": "Thử lại",
    "emptyNone": "Chưa có nhà cung cấp nào.",
    "emptySearch": "Không có nhà cung cấp nào khớp từ khoá này.",
    "rowsPerPage": "Số dòng mỗi trang:",
    "showingRange": "Đang xem {{from}}–{{to}} trong {{total}} nhà cung cấp",
    "prevPage": "Trang trước",
    "nextPage": "Trang sau",
    "paginationAria": "Phân trang danh sách nhà cung cấp",
    "statusToggleAria": "Đổi trạng thái của {{name}}",
    "editAria": "Sửa {{name}}",
    "productsAria": "Xem sản phẩm của {{name}}",
    "statusSaved": "Đã lưu trạng thái.",
    "statusFailed": "Không đổi được trạng thái",
    "manageLink": "Xem bản đầy đủ",
    "toggleReason": "Trạng thái được đổi từ danh sách nhà cung cấp bởi quản trị viên.",
    "statusError": {
      "notFound": "Nhà cung cấp này không còn tồn tại, hoặc không phải tài khoản nhà cung cấp.",
      "stateInvalid": "Chỉ nhà cung cấp đang bị tạm ngưng mới kích hoạt lại được — nhà cung cấp này không ở trạng thái tạm ngưng.",
      "alreadySuspended": "Nhà cung cấp này đã bị tạm ngưng rồi.",
      "internal": "Máy chủ không hoàn tất được thay đổi. Hãy thử lại, hoặc liên hệ hỗ trợ nếu vẫn lỗi.",
      "generic": "Máy chủ từ chối thay đổi và không nêu lý do."
    }
  },
  "productsSheet": {
    "title": "Sản phẩm — {{vendor}}",
    "subtitle": "Các sản phẩm nhà cung cấp này sản xuất và giao được.",
    "close": "Đóng",
    "authLoading": "Đang kiểm tra quyền…",
    "authError": "Không tải được quyền của bạn nên tạm thời không sửa được.",
    "authRetry": "Thử lại",
    "searchPlaceholder": "Tìm sản phẩm...",
    "colProductType": "Loại sản phẩm",
    "colProductCode": "Mã sản phẩm",
    "colDateCreated": "Ngày tạo",
    "colUserCreated": "Người tạo",
    "colStatus": "Trạng thái",
    "loading": "Đang tải sản phẩm…",
    "loadError": "Không tải được sản phẩm của nhà cung cấp này.",
    "emptyNone": "Nhà cung cấp này chưa có sản phẩm nào.",
    "emptySearch": "Không có sản phẩm nào khớp từ khoá này.",
    "showingRange": "Đang xem {{from}}–{{to}} trong {{total}} sản phẩm",
    "statusToggleAria": "Bật/tắt {{name}}",
    "statusSaved": "Đã cập nhật trạng thái sản phẩm.",
    "statusError": "Không đổi được trạng thái sản phẩm.",
    "statusConflict": "Trạng thái sản phẩm vừa thay đổi. Tải lại rồi thử lại.",
    "statusLocked": "Sản phẩm đang chờ duyệt hoặc bị từ chối được đổi qua luồng duyệt.",
    "confirmOffTitle": "Tắt sản phẩm này?",
    "confirmOffBody": "{{name}} sẽ tắt ngay, không chờ hết 7 ngày báo trước của vendor.",
    "confirmOff": "Tắt",
    "cancel": "Huỷ",
    "openSkusAria": "Mở danh sách SKU của {{name}}",
    "statusFilterAll": "Trạng thái: Tất cả",
    "statusFilterActive": "Trạng thái: Hoạt động",
    "statusFilterInactive": "Trạng thái: Ngừng",
    "refreshing": "Đang làm mới…",
    "skus": {
      "back": "Quay lại danh sách sản phẩm",
      "subtitle": "Quản lý SKU, giá, kích thước và phí vận chuyển của sản phẩm này.",
      "searchPlaceholder": "Tìm SKU...",
      "bulkOrder": "Đơn số lượng lớn",
      "bulkAllAria": "Đơn số lượng lớn cho mọi SKU của sản phẩm",
      "bulkPartial": "{{count}}/{{total}}",
      "bulkConfirmOnTitle": "Bật đơn số lượng lớn cho mọi SKU?",
      "bulkConfirmOffTitle": "Tắt đơn số lượng lớn cho mọi SKU?",
      "bulkConfirmBody": "Thao tác này đổi cả {{total}} SKU của sản phẩm, kể cả SKU không nằm ở trang này.",
      "bulkConfirm": "Áp dụng",
      "bulkSaved": "Đã cập nhật đơn số lượng lớn cho {{count}} SKU.",
      "colSkuName": "Tên SKU",
      "colSkuCode": "Mã SKU",
      "colCostPrice": "Giá vốn",
      "colHandleFee": "Phí xử lý",
      "colDimension": "Kích thước",
      "colShippingInfo": "Vận chuyển",
      "colBulkOrder": "Số lượng lớn",
      "colStatus": "Trạng thái",
      "dimensionValue": "{{l}} × {{w}} × {{h}} cm · {{g}}g",
      "editDimensionsAria": "Sửa kích thước của {{sku}}",
      "view": "Xem",
      "hide": "Ẩn",
      "shippingToggleAria": "Thông tin vận chuyển của {{sku}}",
      "skuStatusAria": "Bật/tắt SKU {{sku}}",
      "skuBulkAria": "Đơn số lượng lớn cho SKU {{sku}}",
      "saved": "Đã cập nhật SKU.",
      "saveError": "Không lưu được SKU.",
      "loading": "Đang tải SKU…",
      "loadError": "Không tải được SKU của sản phẩm này.",
      "emptyNone": "Sản phẩm này chưa có SKU.",
      "emptySearch": "Không có SKU nào khớp.",
      "showingRange": "Hiển thị {{from}}–{{to}} trên {{total}} SKU",
      "linkMapped": "Đã map · chờ duyệt",
      "linkAllocated": "Đã liên kết · có allocation",
      "linkNoAllocation": "Đã liên kết · chưa có allocation"
    },
    "dimensions": {
      "title": "Đặt kích thước",
      "subtitle": "Cấu hình kích thước hộp",
      "weight": "Cân nặng",
      "boxHeight": "Chiều cao hộp",
      "boxWidth": "Chiều rộng hộp",
      "boxLength": "Chiều dài hộp",
      "unitG": "g",
      "unitCm": "cm",
      "save": "Lưu",
      "cancel": "Huỷ",
      "invalid": "Nhập số lớn hơn 0.",
      "rejected": "Giá trị này không được chấp nhận. Vui lòng kiểm tra lại.",
      "saved": "Đã lưu kích thước."
    },
    "shipping": {
      "colService": "Tên dịch vụ",
      "colShippingFee": "Phí vận chuyển",
      "colShippingCost": "Chi phí vận chuyển",
      "colTariff": "Thuế đối ứng",
      "colAdditionalFee": "Phí thêm",
      "colAdditionalCost": "Chi phí thêm",
      "colStatus": "Trạng thái",
      "emptyMethods": "Chưa có dịch vụ vận chuyển nào đang hoạt động. Thêm ở Vendors → Services.",
      "statusAria": "{{service}} cho SKU này",
      "invalidAmount": "Nhập số tiền dạng 5.00",
      "feeAria": "{{field}} — {{service}}",
      "required": "Bắt buộc",
      "unsavedSummary": "Chưa lưu: {{changes}} ở {{skus}}",
      "unsavedChanges_one": "{{count}} thay đổi chưa lưu",
      "unsavedChanges_other": "{{count}} thay đổi chưa lưu",
      "skuCount_one": "{{count}} SKU",
      "skuCount_other": "{{count}} SKU",
      "invalidCount_one": "{{count}} ô cần sửa",
      "invalidCount_other": "{{count}} ô cần sửa",
      "invalidElsewhere": "Ở trang hoặc bộ lọc khác: {{skus}}",
      "saveAll": "Lưu thay đổi",
      "discardAll": "Huỷ thay đổi",
      "savedBatch_one": "Đã lưu {{count}} dòng vận chuyển.",
      "savedBatch_other": "Đã lưu {{count}} dòng vận chuyển.",
      "savedNothing": "Không có gì thay đổi.",
      "leaveTitle": "Thay đổi chưa lưu",
      "leaveBody_one": "Bạn có {{count}} thay đổi chưa lưu. Lưu trước khi rời đi?",
      "leaveBody_other": "Bạn có {{count}} thay đổi chưa lưu. Lưu trước khi rời đi?",
      "leaveSave": "Lưu & tiếp tục",
      "leaveDiscard": "Bỏ thay đổi",
      "leaveStay": "Ở lại",
      "leaveInvalid": "Có ô không hợp lệ — sửa lại hoặc bỏ thay đổi.",
      "editedAria": "đã sửa",
      "saveError": "Không lưu được thay đổi vận chuyển.",
      "rowRefused": "Chưa lưu — dòng này bị từ chối.",
      "discardRow": "Bỏ nháp dòng này",
      "markDraft": "có thay đổi vận chuyển chưa lưu",
      "markError": "có ô vận chuyển cần sửa"
    },
    "pricing": {
      "costAria": "Giá vốn của {{sku}}",
      "handleAria": "Phí xử lý của {{sku}}",
      "costLocked": "Sản phẩm đang chờ duyệt — giá vốn bị khoá cho tới khi duyệt xong.",
      "required": "Bắt buộc",
      "invalidAmount": "Nhập số tiền dạng 5.00",
      "savedBatch_one": "Đã lưu giá của {{count}} SKU.",
      "savedBatch_other": "Đã lưu giá của {{count}} SKU.",
      "savedAll": "Đã lưu giá và vận chuyển.",
      "partialSaved": "Đã lưu giá; thay đổi vận chuyển chưa được lưu.",
      "saveError": "Không lưu được giá. Chưa có gì được lưu.",
      "errCostGuard": "Giá vốn phải thấp hơn giá bán thấp nhất cho merchant.",
      "errCostGuardTier": "Giá vốn phải thấp hơn giá bán thấp nhất cho merchant ({{tier}}).",
      "errPending": "Sản phẩm đang chờ duyệt — chưa sửa được giá vốn.",
      "errConfigNotApproved": "Liên kết Printway của SKU này đang chờ duyệt.",
      "errPricingMissing": "SKU Printway chưa có giá bán cho merchant.",
      "errNotFound": "SKU này không còn tồn tại.",
      "errRefused": "Chưa lưu — giá trị này bị từ chối."
    }
  },
  "services": {
    "pageTitle": "Dịch vụ vận chuyển",
    "pageSubtitle": "Quản lý dịch vụ vận chuyển, phương thức giao hàng và cấu hình thời gian vận chuyển.",
    "searchPlaceholder": "Tìm dịch vụ...",
    "create": "Tạo mới",
    "colImage": "Ảnh",
    "colName": "Tên dịch vụ",
    "colCode": "Mã dịch vụ",
    "colDescription": "Mô tả",
    "colShippingTime": "Thời gian vận chuyển",
    "colStatus": "Trạng thái",
    "colActions": "Hành động",
    "loading": "Đang tải dịch vụ…",
    "loadError": "Không tải được danh sách dịch vụ.",
    "retry": "Thử lại",
    "emptyNone": "Chưa có dịch vụ vận chuyển nào.",
    "emptySearch": "Không có dịch vụ nào khớp từ khoá này.",
    "rowsPerPage": "Số dòng mỗi trang:",
    "showingRange": "Đang xem {{from}}–{{to}} trong {{total}} dịch vụ",
    "prevPage": "Trang trước",
    "nextPage": "Trang sau",
    "paginationAria": "Phân trang danh sách dịch vụ",
    "statusToggleAria": "Đổi trạng thái của {{name}}",
    "editAria": "Sửa {{name}}",
    "statusSaved": "Đã lưu trạng thái.",
    "statusFailed": "Không đổi được trạng thái",
    "carrierHint": "Chưa gắn với hãng vận chuyển nào — gắn ở Vận chuyển › Cấu hình › Dịch vụ.",
    "breadcrumbServices": "Dịch vụ",
    "breadcrumbShipping": "Vận chuyển",
    "breadcrumbCreate": "Tạo mới",
    "breadcrumbEdit": "Chỉnh sửa",
    "createTitle": "Tạo dịch vụ vận chuyển",
    "createSubtitle": "Thêm một dịch vụ vận chuyển mới vào hệ thống.",
    "editTitle": "Sửa dịch vụ vận chuyển",
    "editSubtitle": "Cập nhật dịch vụ vận chuyển này.",
    "sectionInfo": "Thông tin dịch vụ",
    "imageLabel": "Ảnh dịch vụ",
    "imageCta": "Bấm để tải lên hoặc kéo thả ảnh vào đây",
    "imageHint": "PNG, JPG tối đa 2MB (nên dùng ảnh vuông 1:1)",
    "imageRemove": "Bỏ ảnh",
    "imageTooLarge": "Ảnh này lớn hơn 2MB.",
    "imageWrongType": "Chỉ nhận ảnh PNG và JPG.",
    "nameLabel": "Tên dịch vụ",
    "namePlaceholder": "Nhập tên dịch vụ",
    "codeLabel": "Mã dịch vụ",
    "codePlaceholder": "ví dụ STD-SHP",
    "codeHint": "Mã duy nhất để nhận diện dịch vụ này.",
    "codeLockedHint": "Không đổi được mã dịch vụ sau khi đã tạo.",
    "descriptionLabel": "Mô tả",
    "descriptionPlaceholder": "Nhập mô tả ngắn cho dịch vụ vận chuyển này",
    "shippingTimeLabel": "Thời gian vận chuyển",
    "shippingTimePlaceholder": "ví dụ 7-14 ngày",
    "shippingTimeHint": "Khoảng thời gian giao hàng dự kiến.",
    "statusLabel": "Trạng thái",
    "statusActive": "Đang hoạt động",
    "statusInactive": "Ngừng hoạt động",
    "statusDraft": "Bản nháp",
    "cancel": "Huỷ",
    "submitCreate": "Tạo dịch vụ",
    "submitSave": "Lưu thay đổi",
    "saving": "Đang lưu…",
    "created": "Đã tạo dịch vụ.",
    "updated": "Đã lưu dịch vụ.",
    "nameRequired": "Phải nhập tên dịch vụ",
    "codeRequired": "Phải nhập mã dịch vụ",
    "codeFormat": "Mã chỉ gồm chữ in hoa, số, - hoặc _ (2–40 ký tự)",
    "codeDuplicate": "Đã có dịch vụ khác dùng mã này",
    "shippingTimeRequired": "Phải nhập thời gian vận chuyển",
    "createFailed": "Không tạo được dịch vụ",
    "updateFailed": "Không lưu được dịch vụ",
    "loadFailed": "Không tải được dịch vụ này"
  }
}
